// extracted by mini-css-extract-plugin
export default {"grid":"NftGridDense_grid__kG7Zr"};